module.exports = __webpack_public_path__ + "static/media/edit.7ecdd7aa.svg";


//////////////////
// WEBPACK FOOTER
// /src/images/icons/partners/edit.svg
// module id = 1173
// module chunks = 0